import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useSnackbar } from 'notistack';
import CloseButton from 'shared/lib/components/snackbar/closeButton';

const snackbarProps = {
  style: {
    width: 500,
    maxWidth: '90%',
  },
};

export default observer(function Snackbar({
  store,
}: {
  store: {
    errorMessage: string | null;
    warningMessage: string | null;
    successMessage: string | null;
  };
}) {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    if (store.errorMessage) {
      const key = store.errorMessage;

      enqueueSnackbar(store.errorMessage, {
        key,
        variant: 'error',
        preventDuplicate: false,
        SnackbarProps: snackbarProps,
        action: (key) => {
          return <CloseButton onClick={() => closeSnackbar(key)}></CloseButton>;
        },
      });

      store.errorMessage = null;
    }
    if (store.warningMessage) {
      const key = store.warningMessage;

      enqueueSnackbar(store.warningMessage, {
        key,
        variant: 'warning',
        preventDuplicate: false,
        SnackbarProps: snackbarProps,
        action: (key) => {
          return <CloseButton onClick={() => closeSnackbar(key)}></CloseButton>;
        },
      });

      store.warningMessage = null;
    }
    if (store.successMessage) {
      const key = store.successMessage;

      enqueueSnackbar(store.successMessage, {
        key,
        variant: 'success',
        preventDuplicate: false,
        SnackbarProps: snackbarProps,
        action: (key) => {
          return <CloseButton onClick={() => closeSnackbar(key)}></CloseButton>;
        },
      });

      store.successMessage = null;
    }
  }, [
    closeSnackbar,
    enqueueSnackbar,
    store,
    store.successMessage,
    store.warningMessage,
    store.errorMessage,
  ]);

  return <></>;
});
